export const USER_LOCK_FETCH_START = 'USER_LOCK_FETCH_START';
export const USER_LOCK_FETCH_END = 'USER_LOCK_FETCH_END';
export const USER_LOCK_LIST_SUCCESS = 'USER_LOCK_LIST_SUCCESS';
export const USER_LOCK_DETAIL_SUCCESS = 'USER_LOCK_DETAIL_SUCCESS';
